/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
 const AbstractItemCommand = require('./AbstractItemCommand');
 const NotificationCenter = require('../notifications/NotificationCenter');
 const Notification = require('../notifications/Notification');

 const removeCurrentSelection = (id, graph) => {
	 const sheetsContainer = graph.streamSheetsContainer;
	 sheetsContainer.enumerateStreamSheetContainers((stscontainer) => {
		 const streamsheet = stscontainer.getStreamSheet();
		 streamsheet.removeSelection(id);
	 });
 };
 const getStreamSheet = (sheetId, graph) => {
	const sheetsContainer = graph.streamSheetsContainer;
	const stsContainer =  sheetsContainer.findStreamSheetContainer((container) => container.model.id === sheetId);
	return stsContainer ? stsContainer.streamSheet : undefined;
 };

 module.exports = class SelectCellsCommand extends AbstractItemCommand {
	 static createFromObject({ data = {} }, { graph }) {
		 return new SelectCellsCommand(graph, data.sheetId, data.selectionId, data.selectedCells);
	 }

	 constructor(graph, sheetId, selectionId, selectedCells) {
		 super(graph);
		 this.data = { sheetId, selectionId, selectedCells };
		 this.isVolatile = true;
		 this._keepFeedback = true;
	 }

	 toObject() {
		 const json = super.toObject();
		 json.data = { ...this.data };
		 return json;
	 }

	 undo() {}

	 redo() {
		 // removeCurrentSelection(this.data.selectionId, this._graphItem.getGraph());
		 if (this.data.selectionId !== 'global') {
			 this._graphItem._userSelections.put(this.data.selectionId, this.data);
			 NotificationCenter.getInstance().send(new Notification('userSelections', {}));
		 }
	 }
 };
